/* Decorative Shopify-hosted SVGs. Keep the inline checkmark until a file loads. */
if (!customElements.get('eg-file-icon')) {
  customElements.define('eg-file-icon', class extends HTMLElement {
    connectedCallback() {
      if (this.iconRequested || !CSS.supports('mask-image', 'url("")')) return;
      const source = this.getAttribute('src');
      if (!source) return;
      this.iconRequested = true;
      const sources = [source, this.getAttribute('fallback-src')].filter(Boolean);
      let sourceIndex = 0;
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        this.style.setProperty('--eg-file-icon', `url("${image.src}")`);
        this.setAttribute('data-loaded', '');
      };
      image.onerror = () => {
        sourceIndex += 1;
        if (sourceIndex < sources.length) image.src = sources[sourceIndex];
      };
      image.src = source;
    }
  });
}
